import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import DropDownInput from "../../../component/Input/dropDownInput/dropDownInput";
import { toast } from "react-toastify";
import SuccessModal from "../../CustomModal/Success";
// import *  as Constants from '../contants';
import ModalPop from '../../modal/modal';
import *  as Constants from '../constants';
import moment from "moment";

const LeadDetails = ({
    // referralDetails=[],
    // referralApproval=[],
    // viewReferralDetails,
    // updateReferralStatus,
    // getAllReferrals,
    getLeadDetails,
    leadDetails=[],
    updateLeadStatus,
    updatedLead=[],
    match,
    history
}) => {
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        lead_id:'',
        utm_source:'',
        name:'',
        contact_no:'',
        category:'',
        call_date:'',
        call_no:'',
        department_id:'',
        next_call_date:'',
        hold_remarks:'',
        rejection_remarks:'',
        other_remarks:'',
        status:'',
        next_action:''
    });
    const [status, setStatus] = useState('');
    const [userOptions, setUserOptions] = useState([]);
    const [leadOptions, setLeadOptions] = useState([]);
    const [accountOptions, setAccountOptions] = useState([]);
    const [userId, setUserId] = useState('');
    const [leadData,setLeadData]=useState();
    const [roleId, setRoleId] = useState('');
    const [showApproveModal,setShowApproveModal]=useState(false);
    const [showHoldModal,setShowHoldModal]=useState(false);
    const [showRejectModal,setShowRejectModal]=useState(false);
    const [rejectionReasons,setRejectionReasons]=useState([]);
    const [holdReasons,setHoldReasons]=useState([]);
    const [departmentOptions,setDepartmentOptions]=useState([]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const res=await getLeadDetails(match.params.id);
            const { lead_data,rejection_reasons,hold_reasons,departments,assignees} = res;
            setLeadData(lead_data);
            setDepartmentOptions(departments);
            setUserOptions(assignees)
            setFormData({
                lead_id:lead_data?.id,
                utm_source:lead_data?.utm_source,
                name:lead_data?.name,
                contact_no:lead_data?.contact_no,
                category:lead_data?.category,
                call_date:new Date().toISOString().split('T')[0] || '',
                call_no:parseInt(lead_data?.total_calls)+1,
                status:lead_data?.status,
                department_id:'',
                next_call_date:'',
                hold_reason:'',
                rejection_reason:'',
                other_remarks:'',
            });
            setRejectionReasons(rejection_reasons??[])
            setHoldReasons(hold_reasons??[])
            // setTeamItems(teams??[])
            setIsLoading(false); 
    
        })();
    }, [getLeadDetails, match.params.id]);

    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name,value)
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleApproval = async () => {
        setIsLoading(true)
        const validateForm = () => {
            if (!formData.department_id) {
                toast.error("Department is required");
                return false;
            }
            if (!formData.account_id) {
                toast.error("Account ID is required");
                return false;
            }
            if (!formData.assigned_user_id) {
                toast.error("Assigned User is required");
                return false;
            }
            if (!formData.next_call_date) {
                toast.error("Next Call Date is Required");
                return false;
            }
            return true;
        };
        try {
            setIsLoading(true);
            console.log(formData)
            if (!validateForm()) {
                setIsLoading(false);     
                return;
            }
            const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_VERIFIED });
            
            if (response.status) {
                setShowApproveModal(false)
                setIsSuccessModalOpen(true)
                
            }else{
                const message=response?.response?.message
                if(message){
                    toast.error(response.response.message)
                }else{
                    toast.error("Something went wrong")
                }
            }
            setIsLoading(false);     
        } catch (error) {
            console.error("Error while approving referral:", error);
            setIsLoading(false);     
        }
    };

    const handleRejection = async () => {
        try {
            const validateForm = () => {
                if (!formData.next_call_date) {
                    toast.error("Next Call Date is Required");
                    return false;
                }
                if (!formData.rejection_reason) {
                    toast.error("Rejection Reason is required");
                    return false;
                }
                if (!formData?.rejection_reason && 
                    (formData?.rejection_reason== Constants?.REJECTION_CITY_NOT_SERVICEABLE || 
                    formData?.rejection_reason == Constants?.REJECTION_OTHER) && 
                    !formData?.other_remarks
                ) {
                    toast.error("Remarks is required");
                    return false;
                }
                return true;
            };

            setIsLoading(true);
            if (!validateForm()) {
                setIsLoading(false);     
                return;
            }
            const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_REJECTED });
            
            if (response.status) {
                setShowRejectModal(false)
                setIsSuccessModalOpen(true)
            }else{
                const message=response?.response?.message
                if(message){
                    toast.error(response.response.message)
                }else{
                    toast.error("Something went wrong")
                }
            }
            setIsLoading(false);         
        } catch (error) {
            console.error("Error while rejecting referral:", error);
            setIsLoading(false);     
        }
    };

    const handleHold = async () => {
        try {
            const validateForm = () => {
                if (!formData?.next_call_date) {
                    toast.error("Next Call Date is Required");
                    return false;
                }
                if (!formData?.hold_reason) {
                    toast.error("Rejection Reason is required");
                    return false;
                }
                if (!formData?.hold_reason && 
                    (formData?.hold_reason== Constants?.HOLD_CITY_NOT_SERVICEABLE || 
                    formData?.hold_reason == Constants?.HOLD_OTHER) && 
                    !formData?.other_remarks
                ) {
                    toast.error("Remarks is required");
                    return false;
                }
                return true;
            };

            setIsLoading(true);
            if (!validateForm()) {
                setIsLoading(false);     
                return;
            }
            const response = await updateLeadStatus({ ...formData, next_action: Constants.LEAD_STATUS_PENDING });
            
            if (response.status) {
                setShowHoldModal(false)
                setIsSuccessModalOpen(true)
            }else{
                const message=response?.response?.message
                if(message){
                    toast.error(response.response.message)
                }else{
                    toast.error("Something went wrong")
                }
            }
            setIsLoading(false);         
        } catch (error) {
            console.error("Error while rejecting referral:", error);
            setIsLoading(false);     
        }
    };

    // const handleClose = async () => {
    //     try {
    //         setIsLoading(true);
    //         const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_CLOSED });
    //         if (response.status) {
    //             setIsSuccessModalOpen(true)
    //         }
    //         setIsLoading(false);     
    //     } catch (error) {
    //         console.error("Error while clossing referral:", error);
    //         setIsLoading(false);     
    //     }
    // };

    // const handleOrderWon = async () => {
    //     try {
    //         setIsLoading(true);
    //         const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_ORDER_WON });
    //         if (response.status) {
    //             setIsSuccessModalOpen(true)
    //         }
    //         setIsLoading(false);     
    //     } catch (error) {
    //         console.error("Error while Updating referral:", error);
    //         setIsLoading(false);     
    //     }
    // };

    // const handleOrderLost = async () => {
    //     try {
    //         if (!formData.remarks) {
    //             toast.error("Remarks are required");
    //             return false;
    //         }
    //         setIsLoading(true);
    //         const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_ORDER_LOST });
    //         if (response.status) {
    //             setIsSuccessModalOpen(true)
    //         }
    //         setIsLoading(false);     
    //     } catch (error) {
    //         console.error("Error while Updating referral 2:", error);
    //         setIsLoading(false);     
    //     }
    // };

    function closeModal() {
        setShowApproveModal(false);
        window.location.reload()
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={'Status updated successfully'}
                url={'pending-leads'}
            />
            <ModalPop
                title="Fill the following details"
                show={showApproveModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                className="modal-lg"
            >
                {/* <div className="container"> */}
                    <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="category" className="form-label">Category</label>
                                <input type="text" id="category" className="form-control" value={formData.category} readOnly disabled/>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="department_id" className="form-label">Department<span className="text-danger">*</span></label>
                                <select
                                    id="department_id"
                                    name="department_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData.department_id || ''}
                                >
                                    <option value="">Choose...</option>
                                    {departmentOptions.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="account_id" className="form-label">Account ID<span className="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    id="account_id" 
                                    className="form-control" 
                                    value={formData.account_id} 
                                    onChange={(e) => setFormData({ ...formData, account_id: e.target.value })} 
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="next_call_date" className="form-label">Meeting Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="next_call_date" 
                                    className="form-control" 
                                    value={formData.next_call_date || ''} 
                                    onChange={(e) => setFormData({ ...formData, next_call_date: e.target.value })} 
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="assignedUser" className="form-label">Assign User<span className="text-danger">*</span></label>
                                <select
                                    id="assignedUser"
                                    name="assigned_user_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.assigned_user_id || ''}
                                >
                                    <option value="">Choose...</option>
                                    {userOptions.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="w-100 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}>
                        <button 
                            type="button" 
                            onClick={handleApproval}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>

            <ModalPop
                title='Fill the following details'
                show={showRejectModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
            >
                <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="category" className="form-label">Category</label>
                                <input type="text" id="category" className="form-control" value={formData.category} readOnly disabled/>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="next_call_date" className="form-label">Next Meeting Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="next_call_date" 
                                    className="form-control" 
                                    value={formData.next_call_date || ''} 
                                    min={new Date().toISOString().split('T')[0]}
                                    onChange={(e) => setFormData({ ...formData, next_call_date: e.target.value })} 
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="rejectionReasons" className="form-label">Rejection Reason<span className="text-danger">*</span></label>
                                <select
                                    id="rejectionReasons"
                                    name="rejection_reason"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.rejection_reason || ''}
                                >
                                    <option value="">Choose...</option>
                                    {rejectionReasons.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            {(formData.rejection_reason== Constants?.REJECTION_CITY_NOT_SERVICEABLE || formData.rejection_reason== Constants?.REJECTION_OTHER )&&
                                <div className="mb-4">
                                    <label htmlFor="other_remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                                    <textarea
                                        id="other_remarks"
                                        name="other_remarks"
                                        className="form-control"
                                        rows="3"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="w-100 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}> 
                        <button 
                            type="button" 
                            onClick={handleRejection}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>
            <ModalPop
                title='Fill the following details'
                show={showHoldModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                // url={url}
            >
                <div className="row g-3"> 
                        {/* First Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="lead_id" className="form-label">Lead ID</label>
                                <input type="number" id="lead_id" className="form-control" value={formData.lead_id} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="utm_source" className="form-label">UTM Source</label>
                                <input type="text" id="utm_source" className="form-control" value={formData.utm_source} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" id="name" className="form-control" value={formData.name} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact_no" className="form-label">Contact No.</label>
                                <input type="text" id="contact_no" className="form-control" value={formData.contact_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="category" className="form-label">Category</label>
                                <input type="text" id="category" className="form-control" value={formData.category} readOnly disabled/>
                            </div>
                        </div>

                        {/* Second Column */}
                        <div className="col-sm-12 col-md-6">
                            <div className="mb-3">
                                <label htmlFor="call_date" className="form-label">Call Date</label>
                                <input type="date" id="call_date" className="form-control" value={formData.call_date} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="call_no" className="form-label">Call No</label>
                                <input type="number" id="call_no" className="form-control" value={formData.call_no} readOnly disabled/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="next_call_date" className="form-label">Next Call Date<span className="text-danger">*</span></label>
                                <input 
                                    type="date" 
                                    id="next_call_date" 
                                    className="form-control" 
                                    value={formData.next_call_date || ''} 
                                    min={new Date().toISOString().split('T')[0]}
                                    onChange={(e) => setFormData({ ...formData, next_call_date: e.target.value })} 
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="holdReasons" className="form-label">Hold Reason<span className="text-danger">*</span></label>
                                <select
                                    id="holdReasons"
                                    name="hold_reason"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.hold_reason || ''}
                                >
                                    <option value="">Choose...</option>
                                    {holdReasons.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {(formData.hold_reason== Constants?.HOLD_CITY_NOT_SERVICEABLE || formData.hold_reason== Constants?.HOLD_OTHER )&&
                                <div className="mb-4">
                                    <label htmlFor="other_remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                                    <textarea
                                        id="other_remarks"
                                        name="other_remarks"
                                        className="form-control"
                                        rows="3"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    {/* </div> */}

                    {/* Submit Button */}
                    <div className="col-md-12 d-flex items-center text-center mt-3" style={
                        {display: "flex",
                        justifyContent: "center"
                        }}>
                        <button 
                            type="button" 
                            onClick={handleHold}
                            className="btn btn-primary px-4" 
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </ModalPop>
            <Loader isLoading={isLoading} />
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title="Lead Details" />
                        <div className="container-fluid bg-light" style={{
                                                                            padding: '0.5rem'
                                                                        }}>
                            <h1 className="h3 mb-4 text-primary">Lead Details</h1>
                            <form className="bg-white p-2 rounded shadow-sm">
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="form-control"
                                        value={leadData?.name || ''}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="contact_no" className="form-label">Contact No</label>
                                    <input
                                        type="text"
                                        id="contact_no"
                                        name="contact_no"
                                        className="form-control"
                                        value={leadData?.contact_no || ''}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input
                                        type="text"
                                        id="email"
                                        name="email"
                                        className="form-control"
                                        value={leadData?.email_id || ''}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="society_name" className="form-label">Society Name</label>
                                    <input
                                        type="text"
                                        id="society_name"
                                        name="society_name"
                                        className="form-control"
                                        value={leadData?.society_name || ''}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="category" className="form-label">Category</label>
                                    <input
                                        type="text"
                                        id="category"
                                        name="category"
                                        className="form-control"
                                        value={leadData?.category || ''}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="city" className="form-label">City</label>
                                    <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        className="form-control"
                                        value={leadData?.city || ''}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="adgroupid" className="form-label">Ad Group ID</label>
                                    <input type="text" id="adgroupid" name="adgroupid" className="form-control" value={leadData?.adgroupid || 'N/A'} disabled />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="utm_term" className="form-label">UTM Term</label>
                                    <input type="text" id="utm_term" name="utm_term" className="form-control" value={leadData?.utm_term || 'N/A'} disabled />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="department_name" className="form-label">Department</label>
                                    <input type="text" id="department_name" name="department_name" className="form-control" value={leadData?.department_name || 'N/A'} disabled />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="created_at" className="form-label">Created At</label>
                                    <input type="date" id="created_at" name="created_at" className="form-control" value={leadData?.created_at ? new Date(leadData.created_at).toISOString().split('T')[0] : ''} disabled />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="total_calls" className="form-label">Total Calls</label>
                                    <input type="number" id="total_calls" name="total_calls" className="form-control" value={leadData?.total_calls || 0} disabled />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="latest_call_date" className="form-label">Latest Call Date</label>
                                    <input type="date" id="latest_call_date" name="latest_call_date" className="form-control" value={leadData?.latest_call_date || 'N/A'} disabled />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="next_call_date" className="form-label">Next Call Date</label>
                                    <input type="date" id="next_call_date" name="next_call_date" className="form-control" value={leadData?.next_call_date ? new Date(leadData.next_call_date+ "Z").toISOString().split('T')[0] : ''} disabled />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="status" className="form-label">Status</label>
                                    <input
                                        type="text"
                                        id="status"
                                        name="status"
                                        className="form-control"
                                        value={leadData?.status_text}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="query" className="form-label">Query</label>
                                    <textarea
                                        type="text"
                                        id="query"
                                        name="query"
                                        className="form-control"
                                        value={leadData?.query || ''}
                                        readOnly
                                        style={{
                                            width: '100%',
                                            minHeight: '200px',
                                            maxHeight: '200px', 
                                            overflowY: 'auto',
                                            resize: 'none',
                                        }}
                                    />
                                </div>
                            </div>
                            </form>
                            <form className="bg-white p-2 rounded shadow-sm mt-3">
                                    <div className="card mb-4 shadow-sm">
                                        <div className="card-header bg-primary text-white">
                                            <h5 className="card-title mb-0">Call Logs</h5>
                                        </div>
                                        <div className="card-body">
                                            {leadData?.call_logs?.length > 0 ? (
                                            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 ">
                                                {leadData.call_logs.map((log, index) => (
                                                <div key={index} className="col">
                                                    <div className="border rounded p-3 bg-light mb-3">
                                                    <p className="d-flex justify-content-between"><strong>Call Date:</strong> {log.call_date}</p>
                                                    <p className="d-flex justify-content-between"><strong>Hold Reason:</strong> {log.hold_reason || 'N/A'}</p>
                                                    <p className="d-flex justify-content-between"><strong>Rejection Reason:</strong> {log.rejection_reason || 'N/A'}</p>
                                                    <p className="d-flex justify-content-between"><strong>Other Remarks:</strong> {log.other_remarks || 'N/A'}</p>
                                                    <p className="d-flex justify-content-between"><strong>Next Action:</strong> {log.next_action || 'N/A'}</p>
                                                    <p className="d-flex justify-content-between"><strong>Next Call Date:</strong> {log.next_call_date}</p>
                                                    <p className="d-flex justify-content-between"><strong>Action By:</strong> {log.action_by}</p>
                                                    </div>
                                                </div>
                                                ))}
                                            </div>
                                            ) : (
                                            <p className="text-muted text-center">No call logs available.</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center">
                                        {leadData?.status == Constants.LEAD_STATUS_PENDING && (
                                            <div className="d-flex justify-content-end mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-success me-3"
                                                    style={{ marginRight: '2rem' }}
                                                    onClick={()=>{
                                                        setIsLoading(true)
                                                        setShowApproveModal(true)
                                                        setIsLoading(false)
                                                    }}
                                                >
                                                    Verify
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-3"
                                                    onClick={()=>{
                                                        setIsLoading(true)
                                                        setShowHoldModal(true)
                                                        setIsLoading(false)
                                                    }}
                                                    style={{
                                                        paddingLeft: '20px',
                                                        paddingRight: '20px'
                                                    }}
                                                >
                                                    Hold
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    style={{ marginLeft: '2rem' }}
                                                    onClick={()=>{
                                                        setIsLoading(true)
                                                        setShowRejectModal(true)
                                                        setIsLoading(false)
                                                    }}
                                                >
                                                    Reject
                                                </button>
                                            </div>
                                        )}
                                    </div> 
                            </form>  
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};

export default LeadDetails;